import React from 'react';

const HomePage = () => (
  <div className="container homepage mt-4 text-wrap fs-6">
    <h3 className="mb-4">Welcome to our page!</h3>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo quasi
      voluptates praesentium saepe veritatis ex, aperiam enim debitis quidem
      sint corrupti ducimus repudiandae fugiat exercitationem vero voluptatem
      quod? Totam iusto magnam modi molestiae at, doloremque alias velit
      blanditiis qui voluptate minima corrupti debitis, ex facere nobis maiores
      quisquam reprehenderit consequatur perferendis. Minus maxime sit velit
      temporibus eaque ad ipsam quidem ipsum voluptate molestiae debitis, hic
      molestias veritatis dolores porro, delectus nostrum odit animi aliquam
      deleniti, fugiat minima doloremque est praesentium. Rerum suscipit, atque
      quam dolor voluptatibus esse optio consequuntur voluptatum aspernatur
      facere delectus tempora culpa voluptates hic dolores quas asperiores.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel dolorem hic
      animi consectetur, deleniti ex nostrum, quo excepturi, atque ipsa expedita
      obcaecati sint quisquam aliquid harum dicta cumque nam saepe optio!
      Voluptates hic eius quaerat unde, quo pariatur aperiam reiciendis
      aspernatur consectetur maiores sint ullam, rerum excepturi, adipisci
      facere earum debitis laboriosam consequatur doloremque mollitia. Deleniti
      cumque eius sed voluptatibus at! Ratione necessitatibus rerum consectetur
      aspernatur est, commodi porro labore soluta aperiam corrupti possimus
      obcaecati vero dolore vitae ab impedit non saepe fuga numquam aliquam?
      Deleniti, excepturi! Quis earum commodi quo corporis et quaerat sunt animi
      doloremque harum, voluptate tenetur.
    </p>
  </div>
);
export default HomePage;
